import CartContent from '~/components/Cart/CartContent';
import { useCartContext } from '~/components/Cart/CartDrawerContext';
import { Sheet } from '~/components/ui/sheet';

export function CartDrawer() {
  const { cartOpen, setCartOpen } = useCartContext();

  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <CartContent />
    </Sheet>
  );
}
